import { render, staticRenderFns } from "./chatBroadcastDialog.vue?vue&type=template&id=c2bea03a&scoped=true"
import script from "./chatBroadcastDialog.vue?vue&type=script&lang=js"
export * from "./chatBroadcastDialog.vue?vue&type=script&lang=js"
import style0 from "./chatBroadcastDialog.vue?vue&type=style&index=0&id=c2bea03a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bea03a",
  null
  
)

export default component.exports